var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"searchResultEmpty"},[_vm._v(" Нічого не знайшли. Будь ласка, перевірте написання або спробуйте шукати за іншим словом. ")])}
var staticRenderFns = []

export { render, staticRenderFns }